export const Orientation = {
    HORIZONTAL: 1,
    VERTICAL: 2,
};

export const Direction = {
    UP: "up",
    LEFT: "left",
    DOWN: "down",
    RIGHT: "right",
};

export const Level = {
    NONE: null,
    DEFAULT: "default",
    INFO: "info",
    PRIMARY: "primary",
    SECONDARY: "secondary",
    SUCCESS: "success",
    WARNING: "warning",
    DANGER: "danger",
    ERROR: "danger",
};

export const Size = {
    NONE: null,
    EXTRA_SMALL: "xs",
    SMALL: "sm",
    MEDIUM: "default",
    DEFAULT: "default",
    LARGE: "lg",
    EXTRA_LARGE: "xl",
};

export const VoteStatus = {
    NONE: null,
    LIKE: 1,
    DISLIKE: 0,
};

export const ActionStatus = {
    DEFAULT: 1,
    RUNNING: 2,
    SUCCESS: 3,
    FAILED: 4,
};
